import { ShieldCheck, CalendarCheck, MessageCircle, Star, Sparkles } from "lucide-react";

const benefits = [
  {
    icon: ShieldCheck,
    title: "Profils vérifiés",
    desc: "Chaque intervenant est vérifié pour votre tranquillité.",
  },
  {
    icon: CalendarCheck,
    title: "Réservation en quelques clics",
    desc: "Trouvez et réservez une garde rapidement, sans stress.",
  },
  {
    icon: MessageCircle,
    title: "Messagerie sécurisée",
    desc: "Échangez directement avec les intervenants en toute confiance.",
  },
];

const AuthMarketingPanel = () => {
  return (
    <div className="relative flex flex-col justify-center h-full px-8 py-12 lg:px-14 xl:px-20 overflow-hidden">
      {/* Immersive gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[hsl(264,100%,28%)] via-[hsl(280,80%,25%)] to-[hsl(249,52%,8%)]" />

      {/* Neon orbs */}
      <div className="neon-orb w-80 h-80 -top-[80px] -right-[60px]" style={{ background: 'hsl(330 100% 65% / 0.2)', filter: 'blur(100px)' }} />
      <div className="neon-orb w-64 h-64 -bottom-[40px] -left-[60px]" style={{ background: 'hsl(264 100% 59% / 0.15)', filter: 'blur(100px)' }} />
      <div className="neon-orb w-40 h-40 top-1/2 left-1/3" style={{ background: 'hsl(190 100% 50% / 0.1)', filter: 'blur(80px)' }} />

      {/* Large watermark logo */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none" style={{ opacity: 0.05 }} aria-hidden="true">
        <img src="/lovable-uploads/2236e7c0-4083-436f-a95c-06d4486b46d6.png" alt="" className="blur-[3px]" style={{ width: '22rem', height: '22rem' }} draggable={false} />
      </div>

      <div className="relative z-10 space-y-10">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <div className="w-14 h-14 rounded-xl overflow-hidden glow-violet border-2 border-primary-foreground/20">
            <img alt="Click&Gard" className="w-14 h-14 object-cover" src="/lovable-uploads/2236e7c0-4083-436f-a95c-06d4486b46d6.png" />
          </div>
          <span className="text-2xl font-extrabold text-primary-foreground tracking-tight font-display">
            Click<span className="text-secondary">&</span>Gard
          </span>
        </div>

        {/* Hero copy */}
        <div className="space-y-5">
          <h1 className="text-3xl lg:text-4xl xl:text-[2.75rem] font-extrabold leading-[1.15] text-primary-foreground tracking-tight font-display">
            Trouvez une garde
            <br />
            <span className="text-secondary">en toute confiance</span>
          </h1>
          <p className="text-primary-foreground/80 text-lg max-w-md leading-relaxed">
            Rejoignez des milliers de familles et professionnels qui se font confiance chaque jour sur Click&Gard.
          </p>
        </div>

        {/* Benefits */}
        <div className="space-y-5">
          {benefits.map((b) => (
            <div key={b.title} className="flex items-start gap-4 group">
              <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-primary-foreground/10 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-foreground/20 transition-all duration-200 glow-violet">
                <b.icon className="w-6 h-6 text-secondary" />
              </div>
              <div>
                <p className="font-bold text-primary-foreground text-base">{b.title}</p>
                <p className="text-primary-foreground/65 text-sm leading-relaxed">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Social proof */}
        <div className="flex items-center gap-4 pt-2">
          <div className="flex -space-x-2">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="w-10 h-10 rounded-full border-2 border-primary-foreground/20 bg-primary-foreground/10 flex items-center justify-center text-xs font-bold text-primary-foreground/70 shadow-sm"
              >
                {["ML", "SD", "TR", "AB"][i - 1]}
              </div>
            ))}
          </div>
          <div>
            <div className="flex items-center gap-0.5">
              {[1, 2, 3, 4, 5].map((s) => (
                <Star key={s} className="w-4 h-4 text-secondary fill-secondary" />
              ))}
            </div>
            <p className="text-primary-foreground/60 text-xs mt-0.5 font-medium">
              Plateforme pensée pour les parents
            </p>
          </div>
        </div>

        {/* Audience tags */}
        <div className="flex flex-wrap gap-2">
          {["Parents", "Baby-sitters", "Assist. maternelles", "Crèches"].map((tag) => (
            <span
              key={tag}
              className="px-4 py-2 rounded-full text-xs font-semibold bg-primary-foreground/10 text-primary-foreground/85 backdrop-blur-sm border border-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors duration-200"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AuthMarketingPanel;
